import ViewCompact from '@mui/icons-material/ViewCompact';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ViewCompactIcon(props: FixMe) {
  return <ViewCompact {...props} />;
}

export default ViewCompactIcon;
